const notificationData = [
  {
    idx: 0,
    type: 'workspace-add',
    title: '워크스페이스에 초대되었습니다.',
    content: 'seung-eun님이 워크스페이스에 초대하였습니다.',
    time: '2024-09-10T16:45:04.930487',
  },
  {
    id: 1,
    type: 'sprint-add',
    title: '스프린트에 할당되었습니다.',
    content: 'seung-eun님이 스프린트의 참여자로 할당하였습니다.',
    time: '2024-09-10T16:45:04.930487',
  },
  {
    id: 2,
    type: 'issue-add',
    title: '이슈의 담당자로 할당되었습니다.',
    content: 'seung-eun님이 이슈의 담당자로 할당하였습니다.',
    time: '2024-09-10T16:45:04.930487',
  },
  {
    id: 3,
    type: 'task-add',
    title: '태스크가 추가되었습니다.',
    content: 'seong-xun님이 태스크의 담당자로 할당하였습니다.',
    time: '2024-09-10T16:45:04.930487',
  },
  {
    id: 4,
    type: 1,
    title: '회의 알림입니다.',
    content: '회의 시작 10분 전입니다.',
    time: '2024-09-10T16:45:04.930487',
  },
  {
    id: 5,
    type: 'task-end',
    title: '태스크 마감 알림입니다.',
    content: '태스크 마감 하루 전입니다.',
    time: '2024-09-10T16:45:04.930487',
  },
  {
    id: 6,
    type: 'sprint-end',
    title: '스프린트 마감 알림입니다.',
    content: '스프린트 마감 이틀 전입니다.',
    time: '2024-09-10T16:45:04.930487',
  },
  {
    type: 1,
    idx: 6,
    title: '스프린트 마감 알림입니다.',
    content: 'sprint01 스프린트 마감 이틀 전입니다.',
    time: '2024-09-10T16:45:04.930487',
  },
];

export default notificationData;
